// extracted by mini-css-extract-plugin
export default {"container":"FooterButton_container__xlDZZ","button":"FooterButton_button__xyXRS"};